import { defineComponent as m, computed as f, h as l, Fragment as u } from "vue";
import h from "./ghl-ui.es986.js";
import p from "./ghl-ui.es854.js";
import o from "./ghl-ui.es855.js";
import { useThemeClass as $ } from "./ghl-ui.es857.js";
import g from "./ghl-ui.es987.js";
const C = Object.assign(Object.assign({}, o.props), {
  titlePlacement: {
    type: String,
    default: "center"
  },
  dashed: Boolean,
  vertical: Boolean
}), y = m({
  name: "Divider",
  props: C,
  setup(t) {
    const {
      mergedClsPrefixRef: d,
      inlineThemeDisabled: r
    } = p(t), s = o("Divider", "-divider", h, g, t, d), n = f(() => {
      const {
        common: {
          cubicBezierEaseInOut: e
        },
        self: {
          color: a,
          textColor: v,
          fontWeight: c
        }
      } = s.value;
      return {
        "--n-bezier": e,
        "--n-color": a,
        "--n-text-color": v,
        "--n-font-weight": c
      };
    }), i = r ? $("divider", void 0, n, t) : void 0;
    return {
      mergedClsPrefix: d,
      cssVars: r ? void 0 : n,
      themeClass: i == null ? void 0 : i.themeClass,
      onRender: i == null ? void 0 : i.onRender
    };
  },
  render() {
    var t;
    const {
      $slots: d,
      titlePlacement: r,
      vertical: s,
      dashed: n,
      cssVars: i,
      mergedClsPrefix: e
    } = this;
    return (t = this.onRender) === null || t === void 0 || t.call(this), l("div", {
      role: "separator",
      class: [`${e}-divider`, this.themeClass, {
        [`${e}-divider--vertical`]: s,
        [`${e}-divider--no-title`]: !d.default,
        [`${e}-divider--dashed`]: n,
        [`${e}-divider--title-position-${r}`]: d.default && r
      }],
      style: i
    }, s ? null : l("div", {
      class: `${e}-divider__line ${e}-divider__line--left`
    }), !s && d.default ? l(u, null, l("div", {
      class: `${e}-divider__title`
    }, this.$slots), l("div", {
      class: `${e}-divider__line ${e}-divider__line--right`
    })) : null);
  }
});
export {
  y as default,
  C as dividerProps
};
